export default __webpack_public_path__ + "static/media/pics_mobile.c6d538f2.png";